// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__qjlhe","copy-btn":"style_copy-btn__qRC34","copy-btn-effect":"style_copy-btn-effect__bC4Z-","transition":"style_transition__KRWLH"};